export enum WorkflowStepGroup {
  PublicationHold = 1,
  PublicationHoldRelease = 2,
  Proposal = 3,
  Authoring = 4,
  DesignProduction = 5,
  ContentProduction = 6,
  LightUpdate = 7,
  DevelopmentalEditing = 8
}
